export default __webpack_public_path__ + "static/majkusiak_night-b7021a314eb7238ee59ff9c09ec100fc.mp3";